module.exports = __webpack_public_path__ + "img/top_15.90e2c5bf.jpg";